import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Dialog, DialogContent, DialogTitle, Box, IconButton } from "@mui/material";
import { ContentCopy, Download } from "@mui/icons-material";

/* Fun ideas for styling
    boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
    background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
*/

const QrCodeDialog: React.FC<{ message: string; downloadfilename?: string; title?: string, onClose: () => void }> = ({
  message,
  downloadfilename,
  title,
  onClose,
}) => {
  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>{title ?? message}</DialogTitle>
      <DialogContent sx={{ padding: 4 }}>
        <Box display="flex" justifyContent="center">
          <QRCodeCanvas id="jcodeid" size={256} level="L" value={message} />
        </Box>
        <Box
          padding={2}
          paddingTop={3}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <IconButton
            onClick={() => {
              const canvas = document.getElementById(
                "jcodeid"
              ) as HTMLCanvasElement;
              const pngUrl = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
              let downloadLink = document.createElement("a");
              downloadLink.href = pngUrl;
              downloadLink.download = `${downloadfilename ?? "nutilogi"}.png`;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            }}
            size="large"
          >
            <Download />
          </IconButton>
          <IconButton
            onClick={() => {
              const canvas = document.getElementById(
                "jcodeid"
              ) as HTMLCanvasElement;
              canvas.toBlob((blob) => {
                if (blob === null) return;
                const item = new ClipboardItem({ "image/png": blob });
                navigator.clipboard.write([item]);
              });
            }}
            size="large"
          >
            <ContentCopy />
          </IconButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default QrCodeDialog;
